import React from "react";
import i18n from "utils/i18n";
import ThemedSafeAreaComponentTop from "components/atoms/ThemedSafeAreaTop";
import ThemedLayout from "components/atoms/ThemedLayout";
import { useShowHamburger } from 'utils/helper-device'
import HelperString from 'utils/helper-string'
import TabbedContent from 'components/molecules/TabbedContent'
import ManagementReportsDownloadTab from 'scenes/management/reports/tabs/Download'
import ManagementReportsScheduleTab from 'scenes/management/reports/tabs/Schedule'

const ManagementReportsIndexScene = () => {
	
	const showHamburger = useShowHamburger();
	
	return (
		<ThemedSafeAreaComponentTop
			top={ false }>

			<ThemedLayout
				title={i18n.t('management:pages.reports.index.title')}
				topNavigation={true}
				topNavigationProps={{
					showHamburgerDrawer: showHamburger
				}}>
				
				<TabbedContent
					key={ HelperString.hash('report-tabs' ) }
					items={[
						{
							key: 'reports_download',
							text: i18n.t('management:pages.reports.download.title'),
							scene: ( props ) => {
								return <ManagementReportsDownloadTab />;
							}
						},
						{
							key: 'reports_download_schedule',
							text: i18n.t('management:pages.reports.schedule.title'),
							scene: ( props ) => {
								return <ManagementReportsScheduleTab />;
							}
						}
					]}
				/>
			</ThemedLayout>
		</ThemedSafeAreaComponentTop>
	);
}

export default ManagementReportsIndexScene
